// extracted by mini-css-extract-plugin
export default {"ProductInfo":"ProductInfo__ProductInfo___a2cdn","label":"ProductInfo__label___rs8C0"};